import Vue from 'vue';

Vue.component("configurator-delivery", {
    data() {
        return {
            selectionExpanded: false,
        };
    },
});
